import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Award, Share2 } from "lucide-react";
import { api } from "@/lib/api";
import { Empty, GenderToggle } from "@/components/Empty";
import { BottomTab } from "@/components/BottomTab";
import { ShareResultModal } from "@/components/ShareResultModal";
import { Toaster } from "sonner";

export default function GlobalRanking() {
  const nav = useNavigate();
  const [gender, setGender] = useState("Men");
  const [data, setData] = useState(null);
  const [shareId, setShareId] = useState(null);

  const load = useCallback(() => {
    api.get(`/ranking?gender=${gender}`).then((r) => setData(r.data)).catch(() => {});
  }, [gender]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="min-h-screen pb-24 bg-surface" data-testid="ranking-page">
      <header className="bg-black px-4 pb-4" style={{ paddingTop: "calc(var(--safe-top) + 16px)" }}>
        <div className="flex items-center gap-3">
          <button data-testid="ranking-back-btn" onClick={() => nav("/")} className="text-white"><ChevronLeft size={32} strokeWidth={2.5} /></button>
          <Award className="text-brand" size={30} />
          <h1 className="text-2xl font-black text-white">Ranking</h1>
        </div>
        <div className="mt-4"><GenderToggle value={gender} onChange={setGender} /></div>
      </header>

      <div className="px-4 pt-4">
        {!data ? null : !data.published ? (
          <Empty icon={<Award size={54} />} title="Ranking non ancora disponibile" subtitle="Sarà pubblicato al termine di tutte le finali" />
        ) : data.rows.length === 0 ? (
          <Empty icon={<Award size={54} />} title="Ranking non disponibile" subtitle="Torna il giorno della gara" />
        ) : (
          <div className="space-y-3">
            {data.rows.map((r) => {
              const podium = r.rank <= 3;
              return (
                <button
                  key={r.athlete_id}
                  data-testid={`share-btn-${r.athlete_id}`}
                  onClick={() => setShareId(r.athlete_id)}
                  className={`w-full text-left bg-surface2 rounded-3xl px-3 py-3 flex items-center gap-3 active:scale-[0.99] transition-transform ${podium ? "border-2 border-brand" : ""}`}
                >
                  <div className={`w-14 h-14 rounded-2xl flex items-center justify-center text-2xl font-black tabular-nums shrink-0 ${podium ? "bg-brand text-onbrand" : "bg-surface3 text-onsurface"}`}>
                    {r.rank}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-black text-onsurface leading-tight break-words">{r.name}</p>
                    {r.instagram && <p className="text-[13px] text-onsurface3 font-secondary break-all">@{r.instagram}</p>}
                    {r.title_big ? <p className="text-[13px] font-black text-onsurface">{r.title_big}</p>
                      : r.title ? <p className="text-[12px] font-bold text-onsurface3">{r.title}</p> : null}
                  </div>
                  <div className="bg-black rounded-2xl px-4 py-2.5 text-center min-w-[76px] shrink-0">
                    <span className="text-brand text-2xl font-black tabular-nums leading-none block">{r.total}</span>
                    <span className="text-brand text-[11px] font-black tracking-widest">PT</span>
                  </div>
                  <Share2 size={18} className="text-onsurface3 shrink-0" />
                </button>
              );
            })}
          </div>
        )}
      </div>

      <ShareResultModal open={!!shareId} onClose={() => setShareId(null)} athleteId={shareId} />
      <Toaster position="top-center" richColors />
      <BottomTab />
    </div>
  );
}
